'use client';

import type { TrafficPoint } from '@lectura/ts-contracts';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

/**
 * Olvasási és ingest események idősoros diagramja.
 * A `data` üres tömb esetén ne rendereljük a chartot, a hívó adjon helyette
 * üres-állapotot.
 */
export function TrafficChart({ data }: { data: TrafficPoint[] }) {
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="trafikSzin" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--color-brand-500)" stopOpacity={0.45} />
              <stop offset="100%" stopColor="var(--color-brand-500)" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="ingestSzin" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--color-accent-500)" stopOpacity={0.4} />
              <stop offset="100%" stopColor="var(--color-accent-500)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="rgba(0,0,0,0.06)" vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={(v: string) => v.slice(5).replace('-', '.')}
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
            width={42}
          />
          <Tooltip
            contentStyle={{
              borderRadius: 12,
              border: '1px solid var(--color-border)',
              fontSize: 12,
              boxShadow: '0 8px 24px -12px rgba(0,0,0,0.18)',
            }}
            labelFormatter={(v: string) => `Dátum: ${v}`}
            formatter={(value: number, name: string) => {
              const cimkek: Record<string, string> = {
                readingEvents: 'Olvasási események',
                ingestJobs: 'Ingest job-ok',
              };
              return [value.toLocaleString('hu-HU'), cimkek[name] ?? name];
            }}
          />
          <Area
            type="monotone"
            dataKey="readingEvents"
            stroke="var(--color-brand-600)"
            strokeWidth={2}
            fill="url(#trafikSzin)"
          />
          <Area
            type="monotone"
            dataKey="ingestJobs"
            stroke="var(--color-accent-600)"
            strokeWidth={2}
            fill="url(#ingestSzin)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
